import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE_URL = `${u}/note`;

/**
 * Primary list endpoint — paginated summaries (no content, no attachments).
 * Returns { content, totalElements, totalPages, number, last }
 * tags: array of tag strings — server applies OR logic
 */
export const getNotesSummaryPage = async ({
  page = 0,
  size = 20,
  q = "",
  type = "ALL",
  sort = "smart",
  tags = [],
} = {}) => {
  const params = new URLSearchParams({ page, size, q, type, sort });
  if (tags.length > 0) params.set("tags", tags.join(","));
  const res = await apiFetch(`${BASE_URL}/page?${params}`);
  if (!res.ok) return { content: [], totalElements: 0, totalPages: 0, number: 0, last: true };
  return res.json();
};

/** Returns all distinct tags for the current user's active notes. */
export const getNotesTags = async () => {
  const res = await apiFetch(`${BASE_URL}/tags`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const getAllNotes = async () => {
  const res = await apiFetch(BASE_URL);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const getSharedNotes = async () => {
  const res = await apiFetch(`${BASE_URL}/shared`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const createNote = async (data) => {
  const res = await apiFetch(BASE_URL, { method: "POST", body: JSON.stringify(data) });
  return res.json();
};

export const getNoteById = async (id) => {
  const res = await apiFetch(`${BASE_URL}/${id}`);
  if (!res.ok) return null;
  return res.json();
};

export const updateNote = async (id, data) => {
  const res = await apiFetch(`${BASE_URL}/${id}`, { method: "PUT", body: JSON.stringify(data) });
  return res.json();
};

export const deleteNote = async (id) => {
  return apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
};

export const emailNote = async (id) => {
  return apiFetch(`${BASE_URL}/${id}/email`, { method: "POST" });
};

export const emailNoteToRecipients = async (id, payload) => {
  return apiFetch(`${BASE_URL}/${id}/email`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
};

export const shareNote = async (id, payload) => {
  return apiFetch(`${BASE_URL}/${id}/share`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
};

export const getNotesByType = async (type) => {
  const res = await apiFetch(`${BASE_URL}/by-type/${type}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const duplicateNote = async (id) => {
  const original = await getNoteById(id);
  if (!original) return null;
  const payload = {
    title: (original.title || "Untitled") + " (copy)",
    content: original.content,
    noteType: original.noteType,
    priority: original.priority,
    status: "ACTIVE",
    tags: original.tags || [],
  };
  return createNote(payload);
};
